import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import type { TrendDataPoint } from './chartTypes'

interface TrendRow {
  date: string
  stamps_added: number
  rewards_redeemed: number
  rewards_unlocked: number
  new_members: number
}

export function useLoyaltyTrends(dateFrom: Date, dateTo: Date) {
  return useQuery({
    queryKey: ['loyalty-trends', dateFrom.toISOString(), dateTo.toISOString()],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('get_loyalty_trends', {
        p_date_from: dateFrom.toISOString(),
        p_date_to: dateTo.toISOString(),
      })
      if (error) throw error
      return ((data as TrendRow[]) ?? []).map((row): TrendDataPoint => ({
        date: row.date,
        stampsAdded: row.stamps_added,
        rewardsRedeemed: row.rewards_redeemed,
        rewardsUnlocked: row.rewards_unlocked,
        newMembers: row.new_members,
      }))
    },
  })
}